<template>
    <div>
        <v-img :src="require('@/assets/molecule/molecule-full-empty.png')" width="600px">
            <v-img :src="require('@/assets/molecule/feelings_1.png')" width="60px" class="f1 circle" @click="open('f1')"></v-img>
            <v-img :src="require('@/assets/molecule/feelings_2.png')" width="50px" class="f2 circle" @click="open('f2')"></v-img>
            <v-img :src="require('@/assets/molecule/feelings_3.png')" width="48px" class="f3 circle" @click="open('f3')"></v-img>

            <v-img :src="require('@/assets/molecule/interests_1.png')" width="60px" class="i1 circle" @click="open('i1')"></v-img>
            <v-img :src="require('@/assets/molecule/interests_2.png')" width="50px" class="i2 circle" @click="open('i2')"></v-img>
            <v-img :src="require('@/assets/molecule/interests_3.png')" width="50px" class="i3 circle" @click="open('i3')"></v-img>

            <v-img :src="require('@/assets/molecule/strengths_1.png')" width="61px" class="s1 circle" @click="open('s1')"></v-img>
            <v-img :src="require('@/assets/molecule/strengths_2.png')" width="58px" class="s2 circle" @click="open('s2')"></v-img>
            <v-img :src="require('@/assets/molecule/strengths_3.png')" width="50px" class="s3 circle" @click="open('s3')"></v-img>
        </v-img>

        <DiagConcept 
            :model="showDiag"
            :item="concept"
            @accept="close" />
    </div>
</template>

<script>
import { gsap } from 'gsap'
import DiagConcept from '@/components/molecule/DiagConcept'

export default {
    data: () => ({
        concept: {
            title: '',
            description: ''
        },
        showDiag: false
    }),
    props: ['concepts'],
    components: {
        DiagConcept
    },
    methods: {
        open(item) {
            let letter = item.substr(0,1);
            let num = item.substr(1,1);

            if (letter == 'f') {
                this.concept = this.concepts.feeling['c'+num];
                this.concept.color = '#FFCE00';
                this.concept.colorText = 'white';
            }
            if (letter == 'i') {
                this.concept = this.concepts.interestedIn['c'+num];
                this.concept.color = '#8E8BD1';
                this.concept.colorText = 'white';
            }
            if (letter == 's') {
                this.concept = this.concepts.goodAt['c'+num];
                this.concept.color = '#7AF4AB';
                this.concept.colorText = 'white';
            }
            
            this.concept.num = num;
            this.showDiag = true;
        },
        close() {
            this.showDiag = false;
            this.concept = {
                title: '',
                description: ''
            };
        }
    }
}
</script>

<style scoped>
    .circle:hover {
        opacity: 1;
        cursor: pointer;
    }

    .f1 {
        position: absolute;
        left: 156px;
        top: 2px;
        opacity: 0;
    }
    .f2 {
        position: absolute;
        left: 98px;
        top: 98px;
        opacity: 0;
    }
    .f3 {
        position: absolute;
        left: 259px;
        top: 37px;
        opacity: 0;
    }

    .i1 {
        position: absolute;
        left: 538px;
        top: 404px;
        opacity: 0;
    }
    .i2 {
        position: absolute;
        left: 517px;
        top: 302px;
        opacity: 0;
    }
    .i3 {
        position: absolute;
        left: 441px;
        top: 460px;
        opacity: 0;
    }

    .s1 {
        position: absolute;
        left: 3px;
        top: 507px;
        opacity: 0;
    }
    .s2 {
        position: absolute;
        left: 39px;
        top: 384px;
        opacity: 0;
    }
    .s3 {
        position: absolute;
        left: 127px;
        top: 552px;
        opacity: 0;
    }
    
</style>
